import {DetailDialog, DetailDialogProps} from "../../../../components/DetailDialog";
import {DISP_MODE, EQUIPMENT_URLS, URL_PARAMS} from "../../../../constants/constants";

export interface HandDetailDialogProps extends Omit<DetailDialogProps, 'title' | 'src'> {
  handId: string,
  // eslint-disable-next-line camelcase,react/require-default-props
  mountPattern?: string,
  // eslint-disable-next-line camelcase,react/require-default-props
  fingertipId?: string,
}

export function HandDetailDialog(props: HandDetailDialogProps) {
  const params = new URLSearchParams();
  params.append(EQUIPMENT_URLS.HAND_DETAIL.QUERY_MOUNT_PATTERN, props.mountPattern ?? '');
  params.append(EQUIPMENT_URLS.HAND_DETAIL.QUERY_FINGERTIP_ID, props.fingertipId ?? '');
  params.append(URL_PARAMS.DISP_MODE, DISP_MODE.POPUP);
  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    <DetailDialog {...props} title='ハンド詳細'
                  src={`${EQUIPMENT_URLS.HAND_DETAIL.URL}/${props.handId}?${params.toString()}`}/>
  )
}
